import React, { useState } from 'react';
import { Flex } from '@ui-library/misc';
import UserDetails from './userDetails';
import AccountDetails from './accountDetails';
import classes from './setupAccount.module.scss';
import { Circle } from './styles';

interface Props {
  token: string;
}
const SetupAccount = (props: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const updateIndex = () => {
    setActiveIndex(activeIndex + 1);
  };

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="column" className={classes.container}>
        {activeIndex === 0 ? (
          <UserDetails token={props.token} updatePage={updateIndex} />
        ) : (
          <AccountDetails />
        )}
      </Flex>

      <Flex justifyContent="center" className={classes.dotsContainer}>
        {Array(2)
          .fill(false)
          .map((i, index) => (
            <Circle key={`circle-${index}`} selected={activeIndex === index} />
          ))}
      </Flex>
    </Flex>
  );
};

export default SetupAccount;
